<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone direita">
                <div class="tags m-b">
                    <a @click="this.projetosOuPlanoAcao = 'projeto', this.carregarProjetos()"
                        :class="projetosOuPlanoAcao === 'projeto' ? 'ativo' : ''">Projetos</a>
                    <a @click="this.projetosOuPlanoAcao = 'planoAcao', this.carregarProjetos()"
                        :class="projetosOuPlanoAcao === 'planoAcao' ? 'ativo' : ''">PAP</a>
                    <a @click="this.projetosOuPlanoAcao = 'protocolo', this.carregarProjetos()"
                        :class="projetosOuPlanoAcao === 'protocolo' ? 'ativo' : ''">PLA, OS, TNC, RAP</a>
                </div>
            </div>
            <div class="m-icone direita">
                <div class="pesquisa">
                    <input type="text" placeholder="Pesquisar Projeto" v-model="projetoSelecionado"
                        @input="filtrarProjetos()" />
                    <a disabled class="icone-pesquisa"></a>
                </div>
            </div>
            <h2>Gestão de Projetos</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="alinha-direita" style="margin-bottom: 5px;">
            <button class="acao-secundaria" @click="baixarXML(projetosOuPlanoAcao)">Baixar relatório</button>
        </div>
        <div class="bloco margem">
            <table class="tabela">
                <tbody>
                    <tr>
                        <th scope="col">
                            Código
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('nome')" style="cursor: pointer;">Nome</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('nome')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('nome')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('status')" style="cursor: pointer;">Status</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('status')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('status')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('dtInicio')" style="cursor: pointer;">Data de Início</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('dtInicio')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('dtInicio')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('dtTermino')" style="cursor: pointer;">Data de Término</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('dtTermino')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('dtTermino')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('tarefasTotal')" style="cursor: pointer;">Qtd. Tarefas</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('tarefasTotal')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('tarefasTotal')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('tarefasPendentes')" style="cursor: pointer;">Pendentes</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('tarefasPendentes')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('tarefasPendentes')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('tarefasAndamento')" style="cursor: pointer;">Andamento</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('tarefasAndamento')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('tarefasAndamento')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('tarefasConcluidas')" style="cursor: pointer;">Concluídas</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('tarefasConcluidas')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('tarefasConcluidas')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('tarefasAtrasadas')" style="cursor: pointer;">Atrasadas</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('tarefasAtrasadas')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('tarefasAtrasadas')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('diasEmExecucao')" style="cursor: pointer;">Dias em execução</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('diasEmExecucao')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('diasEmExecucao')"></i>
                        </th>
                        <th scope="col">
                            <span @click="ordenarLista('tarefasPorcentagemConcluidas')" style="cursor: pointer;">Conclusão</span>
                            <i class="bi bi-caret-down-fill" v-show="mostrarSetaBaixo('tarefasPorcentagemConcluidas')"></i>
                            <i class="bi bi-caret-up-fill" v-show="mostrarSetaCima('tarefasPorcentagemConcluidas')"></i>
                        </th>
                    </tr>
                    <tr v-for="projeto in listaProjetosFiltrada" :key="projeto">
                        <td>
                            {{ projeto.pcm_codigo ? projeto.pcm_codigo : '-' }}
                        </td>
                        <td>
                            {{ projeto.nome }}
                        </td>
                        <td>
                            {{ projeto.status }}
                        </td>
                        <td>
                            {{ formatarDataBr(projeto.dtInicio) }}
                        </td>
                        <td>
                            {{ formatarDataBr(projeto.dtTermino) }}
                        </td>
                        <td>
                            {{ projeto.tarefasTotal }}
                        </td>
                        <td>
                            {{ projeto.tarefasPendentes }}
                        </td>
                        <td>
                            {{ projeto.tarefasAndamento }}
                        </td>
                        <td>
                            {{ projeto.tarefasConcluidas }}
                        </td>
                        <td>
                            {{ projeto.tarefasAtrasadas }}
                        </td>
                        <td>
                            {{ projeto.diasEmExecucao }} Dias
                        </td>
                        <td>
                            {{ projeto.tarefasPorcentagemConcluidas }} %
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { formatarDataBr } from "@/utils/date";
import { useApiError } from "@/composables/useApiError";
import { useOrdenacaoColuna } from "@/composables/useOrdenacaoColuna";
import serviceGestaoPRJ from "@/services/serviceGestaoProjetos";

export default {
    setup() {
        const { handleError } = useApiError({ message: "Não foi possível carregar os projetos." });
        const { sortKey, sortOrder, toggleOrdenacao } = useOrdenacaoColuna('status', 'asc');
        return { handleApiError: handleError, sortKey, sortOrder, toggleOrdenacao };
    },
    name: "gestaoProjetos",

    data() {
        return {
            projetoSelecionado: null,
            listaProjetosFiltrada: [],
            projetos: [],
            projetosOuPlanoAcao: 'projeto'
        }
    },
    mounted() {
        this.carregarProjetos()
    }, 
    methods: {
        formatarDataBr,
        baixarXML(projetosOuPlanoAcao) {
            serviceGestaoPRJ.baixarXML(projetosOuPlanoAcao);
        },

        mostrarSetaBaixo(key) {
            return this.sortKey === key && this.sortOrder === 'desc';
        },
        mostrarSetaCima(key) {
            return this.sortKey === key && this.sortOrder === 'asc';
        },
        ordenarLista(chaveColuna) {
            this.toggleOrdenacao(chaveColuna);
            this.aplicarOrdenacao();
        },
        aplicarOrdenacao() {
            const key = this.sortKey;
            if (!key) {
                this.filtrarProjetos();
                return;
            }
            const asc = this.sortOrder === 'asc';
            const coef = asc ? 1 : -1;
            const colunasNumericas = ['tarefasTotal', 'tarefasPendentes', 'tarefasAndamento', 'tarefasConcluidas', 'tarefasAtrasadas', 'tarefasPorcentagemConcluidas', 'diasEmExecucao'];
            if (colunasNumericas.includes(key)) {
                this.projetos = [...this.projetos].sort((a, b) => coef * (Number(a[key]) - Number(b[key])));
            } else if (key === 'dtInicio' || key === 'dtTermino') {
                this.projetos = [...this.projetos].sort((a, b) => coef * (new Date(a[key]) - new Date(b[key])));
            } else if (key === 'status') {
                const ordemStatus = { 'Em andamento': 1, 'Aprovado': 2, 'Proposto': 3, 'Concluído': 4, 'Suspenso': 5 };
                this.projetos = [...this.projetos].sort((a, b) => {
                    const oA = ordemStatus[a.status] ?? 0;
                    const oB = ordemStatus[b.status] ?? 0;
                    return coef * (oA - oB);
                });
            } else {
                this.projetos = [...this.projetos].sort((a, b) => {
                    const sa = (a[key] ?? '').toString().toLowerCase();
                    const sb = (b[key] ?? '').toString().toLowerCase();
                    return coef * (sa < sb ? -1 : sa > sb ? 1 : 0);
                });
            }
            this.filtrarProjetos();
        },

        filtrarProjetos() {
            if (!this.projetoSelecionado) {
                this.listaProjetosFiltrada = this.projetos;
            } else {
                const textoLowerCase = this.projetoSelecionado.toLowerCase();
                this.listaProjetosFiltrada = this.projetos.filter(projeto => {
                    return Object.values(projeto).some(value => {
                        if (typeof value === 'string') {
                            return value.toLowerCase().includes(textoLowerCase);
                        } else if (typeof value === 'number') {
                            return value.toString().toLowerCase().includes(textoLowerCase);
                        }
                        return false;
                    });
                });
            }
        },

        async carregarProjetos() {
            try {
                this.projetos = await serviceGestaoPRJ.buscarProjetos(this.projetosOuPlanoAcao);
                this.projetos = this.projetos.map(projeto => {
                    return {
                        ...projeto,
                        diasEmExecucao: this.calculateDaysDifference(projeto.dtInicio)
                    };
                });
                this.filtrarProjetos();
                this.aplicarOrdenacao();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        calculateDaysDifference(data) {
            const differenceInTime = new Date() - new Date(data);
            const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
            return differenceInDays
        }
    }
}

</script>
<style>
td {
    text-align: center;
}

/* th {
    position: sticky !important;
    top: 0 !important;
    z-index: 999 !important;
    background-color: var(--cor-bg);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    text-align: center !important;
} */
</style>
